import Vue from 'vue'
import Vuex from 'vuex'

import categories from './categories'
import products from './products'
import services from './services'
import search from './search'
import company from './company'
import user from './user'

Vue.use(Vuex)

const modules = {
  categories,
  products,
  services,
  search,
  company,
  user
}

const store = new Vuex.Store({
  modules,
  state: {  },
  mutations: {  },
  actions: { }
})

if (module.hot) {
  const paths = Object.keys(modules)
    .map(moduleName => `./${moduleName}`)

  module.hot.accept(paths, () => {
    const updatedModules = {}

    Object.keys(modules).forEach((moduleName) => {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      updatedModules[moduleName] = require(`./${moduleName}`).default
    })

    store.hotUpdate({
      modules: updatedModules
    })
  })
}

export default store
